import { render, staticRenderFns } from "./batchSetting.vue?vue&type=template&id=910d6e5c&scoped=true&"
import script from "./batchSetting.vue?vue&type=script&lang=js&"
export * from "./batchSetting.vue?vue&type=script&lang=js&"
import style0 from "./batchSetting.vue?vue&type=style&index=0&id=910d6e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910d6e5c",
  null
  
)

export default component.exports